import { useCallback, useState } from "react"
import { useMutation, useQueryClient } from "react-query";
import { USER_MODULE_ACTION, useUserModuleDispatch } from ".."
import Network from "../../network";
import NetworkError from "../../network/error";

export default function useCreateUser() {

    const dispatch = useUserModuleDispatch();
    const [error, setError] = useState<NetworkError | null>(null);
    const queryClient = useQueryClient()

    const checkLibraryCode = useMutation(Network.getLibrary, {
        onSuccess: data => {
            queryClient.setQueriesData(['library', data.code], data);
        }
    })

    const createUser = useCallback((login: string, libraryCode: string) => {
        setError(null);
        checkLibraryCode.mutate({
            code: libraryCode
        }, {
            onSuccess: (response) => {
                dispatch({
                    type: USER_MODULE_ACTION.CREATE_USER,
                    payload: {
                        name: login,
                        libraryCode: libraryCode
                    }
                });
            },
            onError(error: any) {
                if (NetworkError.isNetworError(error)) {
                    setError(error)
                } else {
                    setError(new NetworkError(10000, 'Nieznany błąd'))
                }
            }
        })

    }, [dispatch, checkLibraryCode, setError])


    return {
        createUser,
        error,
        isLoading: checkLibraryCode.isLoading
    }
}
